export const CLEAR_DISCOUNT_TO_BENEFICIARY = 'CLEAR_DISCOUNT_TO_BENEFICIARY';
export const FLAG_DISCOUNT_TO_BENEFICIARY_ACTIVITY =
  'FLAG_DISCOUNT_TO_BENEFICIARY_ACTIVITY';
